import { render, staticRenderFns } from "./SettlementKasbonView.vue?vue&type=template&id=4872985f"
import script from "./SettlementKasbonView.vue?vue&type=script&lang=js"
export * from "./SettlementKasbonView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports